<template>
    <b-row>
        <h2 class="pl-1">
            Клиенты
            <small v-if="pagination.total !== null" class="text-muted">
                — найдено клиентов: {{ pagination.total }}
            </small>
        </h2>

        <!--  FILTERS  -->
        <b-col cols="12" class="mb-2">
            <b-row class="align-items-end">
                <b-col md="3" sm="12" class="mb-1">
                    <b-form-group label="ID клиента" label-for="client-id-filter" class="mb-0">
                        <b-input-group size="md">
                            <b-form-input
                                id="client-id-filter"
                                v-model="filters.id"
                                type="number"
                                placeholder="ID"
                            />
                            <b-input-group-append>
                                <b-button
                                    :disabled="!filters.id"
                                    @click="filters.id = ''"
                                >
                                    Очистить
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>

                <b-col md="4" sm="12" class="mb-1">
                    <b-form-group label="Телефон" label-for="client-phone-filter" class="mb-0">
                        <b-input-group size="md">
                            <b-form-input
                                id="client-phone-filter"
                                v-model="filters.phone"
                                type="search"
                                placeholder="Номер телефона"
                            />
                            <b-input-group-append>
                                <b-button
                                    :disabled="!filters.phone"
                                    @click="filters.phone = ''"
                                >
                                    Очистить
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>

                <b-col md="2" sm="12" class="mb-1">
                    <b-form-group label="Дата создания от" label-for="client-created-at-from-filter" class="mb-0">
                        <b-input-group size="md">
                            <b-form-datepicker
                                id="client-created-at-from-filter"
                                v-model="filters.created_at.from"
                                hide-header
                                locale="ru"
                            />
                            <b-input-group-append>
                                <b-button
                                    :disabled="!filters.created_at.from"
                                    @click="filters.created_at.from = ''"
                                >
                                    Очистить
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>

                <b-col md="2" sm="12" class="mb-1">
                    <b-form-group label="Дата создания до" label-for="client-created-at-to-filter" class="mb-0">
                        <b-input-group size="md">
                            <b-form-datepicker
                                id="client-created-at-to-filter"
                                v-model="filters.created_at.to"
                                :disabled="!filters.created_at.from"
                                :min="minCreatedAtDate"
                                hide-header
                                locale="ru"
                            />
                            <b-input-group-append>
                                <b-button
                                    :disabled="!filters.created_at.to"
                                    @click="filters.created_at.to = ''"
                                >
                                    Очистить
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-col>

        <!--  TABLE  -->
        <b-col cols="12">
            <b-table striped hover responsive sort-icon-left :busy="isBusy" :items="items" :fields="fields"
                @sort-changed="handleSortChange">
                <template #table-busy>
                    <div class="text-center text-primary my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong class="ml-1">Идет загрузка ...</strong>
                    </div>
                </template>

                <template #cell(active)="data">
                    <span v-if="data.item.active">Активен</span>
                    <span v-else>Не активен</span>
                </template>

                <template #cell(created_at)="data">
                    <span>{{
                new Date(data.item.created_at).toLocaleDateString("ru")
            }}</span>
                </template>

                <template #cell(crud_row)="{ item }">
                    <div class="d-flex float-right">
                        <router-link :to="{ name: 'client-view', params: { id: item.id }, }">
                            <b-button variant="outline-success" class="update__btn" size="sm">
                                <feather-icon icon="EyeIcon" size="18" />
                            </b-button>
                        </router-link>
                    </div>
                </template>
            </b-table>
        </b-col>

        <!--  PAGINATION  -->
        <b-col cols="12" class="mb-3 d-flex justify-content-between align-items-center">
            <b-form-select class="float-right col-1" v-model="pagination.perPage" placeholder="Выберите"
                :options="pagination.perPageOptions">
            </b-form-select>
            <b-pagination v-model="pagination.page" :total-rows="pagination.total" :per-page="pagination.perPage"
                align="center" size="sm" class="my-0" />
        </b-col>
    </b-row>
</template>

<script>
import {
    BTable,
    BRow,
    BCol,
    BFormGroup,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BFormSelect,
    BFormDatepicker,
} from "bootstrap-vue";
import api from "@/services/api";
import Transactions from "@/services/transactions";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
    paginationData,
} from "@/util/pagination-helper";
import permissionComputeds from "@/util/permissionComputeds";
import { debounce } from "@/util/helper";
const tapi = new Transactions();

export default {
    name: "AppDealers",
    components: {
        BTable,
        BRow,
        BCol,
        BFormGroup,
        BPagination,
        BInputGroup,
        BFormInput,
        BInputGroupAppend,
        BButton,
        BSpinner,
        BFormSelect,
        BFormDatepicker,
        ToastificationContent,
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            apiEntry: "dealers",
            name: null,
            isBusy: false,
            filters: {
                id: "",
                phone: "",
                created_at: {
                    from: "",
                    to: "",
                },
            },
            fields: [
                {
                    key: "id",
                    label: "ID",
                    sortable: true,
                },
                {
                    key: 'first_name',
                    label: 'Имя'
                },
                {
                    key: 'last_name',
                    label: 'Фамилия'
                },
                {
                    key: 'phone',
                    label: 'Телефон'
                },
                {
                    key: 'wallet.balance',
                    label: 'Баланс'
                },
                {
                    key: "active",
                    label: "Статус",
                },
                {
                    key: "created_at",
                    label: "Дата создания",
                    sortable: true,
                },
                {
                    key: 'crud_row',
                    label: ''
                }
            ],
            items: [],
            pagination: paginationData(),
        };
    },
    watch: {
        "pagination.page": {
            async handler(val) {
                const params = new URLSearchParams(window.location.search);

                if (val !== params.get("page")) {
                    this.generateParams();
                    await this.getData();
                }
            },
        },
        "pagination.sorting": {
            async handler() {
                this.pagination.page = 1;
                this.generateParams();
                await this.getData();
            },
        },
        "pagination.perPage": {
            async handler(val) {
                const params = new URLSearchParams(window.location.search);

                if (val !== params.get("perPage")) {
                    this.pagination.page = 1;
                    this.generateParams();
                    await this.getData();
                }
            },
        },
        filters: {
            deep: true,
            handler: debounce(async function handler() {
                this.pagination.page = 1;
                this.generateParams();
                await this.getData();
            }, 400),
        },
    },

    async mounted() {
        this.setParams();
        await this.getData();
    },

    computed: {
        ...permissionComputeds("dealer"),
        editPageName() {
            return this.apiEntry.slice(0, -1) + "-edit";
        },
        showPagination() {
            return (
                this.pagination.total > this.pagination.perPage && !this.isBusy
            );
        },
        minCreatedAtDate() {
            return this.filters.created_at.from
                ? new Date(this.filters.created_at.from)
                : null;
        },
    },

    methods: {
        /////////////
        handleSortChange(ctx) {
            if (!ctx.sortBy) {
                this.pagination.sorting = "";
                return;
            }

            const sortingColumnMap = {
                id: "id",
                created_at: "created_at",
            };
            const order = ctx.sortDesc ? "desc" : "asc";
            this.pagination.sorting = `${sortingColumnMap[ctx.sortBy]},${order}`;
        },
        generateParams() {
            const params = new URLSearchParams(window.location.search);

            params.set("page", this.pagination.page);
            params.set("perPage", this.pagination.perPage);

            if (this.filters.id) {
                params.set("filters[id]", this.filters.id);
            } else {
                params.delete("filters[id]");
            }

            if (this.filters.phone) {
                params.set("filters[phone]", this.filters.phone);
            } else {
                params.delete("filters[phone]");
            }

            params.delete("filters[created_at][]");
            params.delete("filters[created_at][0]");
            params.delete("filters[created_at][1]");

            if (this.filters.created_at.from) {
                params.append("filters[created_at][]", this.filters.created_at.from);
            }

            if (this.filters.created_at.to) {
                params.append("filters[created_at][]", this.filters.created_at.to);
            }

            if (this.pagination.sorting) {
                const [col, ord] = this.pagination.sorting.split(",");
                params.set("sort[column]", col);
                params.set("sort[direction]", ord);
            } else {
                params.delete("sort[column]");
                params.delete("sort[direction]");
            }

            const url = `${window.location.pathname}?${params.toString()}`;
            window.history.pushState({ path: url }, "", url);
        },
        setParams() {
            const searchParams = new URLSearchParams(window.location.search);
            ["page", "perPage"].forEach((el) => {
                if (searchParams.has(el)) {
                    this.pagination[el] = searchParams.get(el);
                }
            });

            if (searchParams.has("filters[id]")) {
                this.filters.id = searchParams.get("filters[id]");
            }

            if (searchParams.has("filters[phone]")) {
                this.filters.phone = searchParams.get("filters[phone]");
            }

            const createdAtDates = searchParams.getAll("filters[created_at][]");
            if (createdAtDates.length) {
                this.filters.created_at.from = createdAtDates[0] || "";
                this.filters.created_at.to = createdAtDates[1] || "";
            } else {
                if (searchParams.has("filters[created_at][0]")) {
                    this.filters.created_at.from = searchParams.get("filters[created_at][0]");
                }

                if (searchParams.has("filters[created_at][1]")) {
                    this.filters.created_at.to = searchParams.get("filters[created_at][1]");
                }
            }

            if (searchParams.has("sort[column]")) {
                const col = searchParams.get("sort[column]");
                const ord = searchParams.get("sort[direction]");
                this.pagination.sorting = `${col},${ord}`;
            }
        },
        getParams() {
            const params = new URLSearchParams();

            if (this.filters.id) {
                params.append("filters[id]", this.filters.id);
            }

            if (this.filters.phone) {
                params.append("filters[phone]", this.filters.phone);
            }

            if (this.filters.created_at.from) {
                params.append("filters[created_at][]", this.filters.created_at.from);
            }

            if (this.filters.created_at.to) {
                params.append("filters[created_at][]", this.filters.created_at.to);
            }

            if (this.pagination.sorting) {
                const [col, ord] = this.pagination.sorting.split(",");
                params.append("sort[column]", col);
                params.append("sort[direction]", ord);
            }

            params.append("page", this.pagination.page);
            params.append("perPage", this.pagination.perPage);

            return params.toString();
        },
        showToast(variant, text, icon) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: text,
                    icon: icon,
                    variant,
                },
            });
        },

        async getData() {
            this.isBusy = true;
            await tapi.fetchClients(this.getParams())
                .then((res) => {
                    this.items = res.data.data;
                    this.pagination.total = res.data.total;
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        deactivateEntry(id, active) {
            api[this.apiEntry]
                .deactivate(id)
                .then(() => {
                    this.getData();
                    if (active === 1) {
                        this.showToast(
                            "success",
                            "Деактивация прошла успешно!",
                            "CheckIcon"
                        );
                    } else {
                        this.showToast(
                            "success",
                            "Активация прошла успешно!",
                            "CheckIcon"
                        );
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.showToast("danger", "Что-то пошло не так!", "XIcon");
                });
        },
    },
};
</script>

<style lang="scss" scoped>
[dir] .dropdown-item {
    padding: 0;
}

//::v-deep .table thead th[aria-colindex="1"] {
//  width: 70px;
//}

.validation__red {
    color: red;
    font-size: 12px;
    display: block;
    margin-bottom: 1rem;
}

.form-group {
    margin-bottom: 6px;
}
</style>
